/* eslint-disable no-unused-vars */
import React, { useCallback, useEffect, useRef, useState } from 'react';
const $ = window.$;

function TableCell(props) {
  const { app, data, em } = props;
  const { handlers } = app || {};

  let inputClass = em.align ? `text-${em.align}` : '';
  switch (em.type) {
    case 'DateCell':
      inputClass = 'text-center';
      break;

    case 'NumberCell':
      inputClass = 'text-right';
      break;

    default:
      break;
  }

  const cellStyle = props.em.cellStyle || {};
  if (em.onCellClick) {
    cellStyle.cursor = 'pointer';
  }

  const [objLang, setObjLang] = useState(props.lang || 'th');
  const [selectedDate, setSelectedDate] = useState(null);
  const [initialized, setInitialized] = useState(false);
  const [requestUpdate, setRequestUpdate] = useState(false);

  const [value, setValue] = useState((props.data && em.field && props.data[em.field]) || '');
  const handleDefaultChange = useCallback((e) => {}, []);

  const handleCellClick = useCallback(
    (e) => {
      e.preventDefault();
      if (!em.onCellClick) return;
      if (!handlers) {
        console.error("'handlers' is not found. 'app' property with 'handlers' must be assigned");
        console.info('<TableGrid em={...} data={...} app={...} />');
        return;
      }
      if (em.onCellClick && handlers[em.onCellClick]) handlers[em.onCellClick](data);
    },
    [data, em.onCellClick, handlers]
  );

  const dateFmtOptions = { day: 'numeric', month: 'short', year: 'numeric' };
  const dateFmt = new Intl.DateTimeFormat(props.locale || 'en-UK', dateFmtOptions);

  const numberFmt = Intl.NumberFormat('en-US', {
    style: 'decimal',
    minimumFractionDigits: em.digits !== undefined ? em.digits : props.digits !== undefined ? props.digits : 2,
    maximumFractionDigits: 2, // em.digits !== undefined ? em.digits : props.digits !== undefined ? props.digits : 2,
  });

  const integerFmt = Intl.NumberFormat('en-US', {
    style: 'decimal',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

  const fractionFmt2 = Intl.NumberFormat('en-US', {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  const refInput = useRef(null);

  useEffect(() => {
    if (em.type !== 'NumberCell') return;
    const _value = props.data && em.field && props.data[em.field];
    setValue(_value);
  }, [em.field, em.type, props.data]);

  useEffect(() => {
    if (em.type !== 'NumberCell') return;
    let _fmtd = '';
    let _value = value;
    if (_value && _value !== '') {
      _value = `${_value}`.replaceAll(',', '');
      _fmtd = numberFmt.format(_value);
    }

    refInput.current.value = _fmtd;
  }, [em.type, numberFmt, value]);

  useEffect(() => {
    if (objLang !== (props.lang || 'th')) {
      setObjLang(props.lang || 'th');
      setInitialized(false);
    }
  }, [objLang, props.lang]);

  useEffect(() => {
    if (em.type !== 'DateCell') return;
    if (initialized) return;

    $(refInput.current).datepicker('destroy');

    $(refInput.current)
      .datepicker({
        language: objLang, // props.lang || 'th',
        format: 'd M yyyy',
      })
      .on('changeDate', (e) => {
        // console.info(e);
        const _date = e.date;
        // _date.setHours(0, 0, 0, 0);

        setSelectedDate(_date);
        setRequestUpdate(true);
      });

    setInitialized(true);
  }, [em.type, initialized, objLang, props]);

  useEffect(() => {
    if (em.type !== 'DateCell') return;
    if (!requestUpdate) return;
    if (em.field && props.onChange) {
      props.onChange({
        target: {
          name: em.field,
          value: selectedDate && selectedDate !== '' ? selectedDate.toISOString() : '',
        },
      });
    }

    setRequestUpdate(false);
  }, [em.field, em.type, props, requestUpdate, selectedDate]);

  useEffect(() => {
    if (em.type !== 'DateCell') return;
    let _date = (props.data && em.field && props.data[em.field]) || '';
    if (_date !== '' && typeof _date !== 'object') _date = new Date(_date);

    // if (typeof _date === 'object') _date.setHours(0,0,0,0);

    $(refInput.current).datepicker('update', _date);
    setSelectedDate(_date);
  }, [em.field, em.type, props.data]);

  const handleBlur = useCallback(
    (e) => {
      if (em.type !== 'NumberCell') return;

      let _fmtd = '';
      let _value = e.target.value;
      if (_value !== '') {
        _value = `${_value}`.replaceAll(',', '');
        setValue(parseFloat(_value));
        _fmtd = numberFmt.format(_value);
      } else {
        setValue('');
      }

      refInput.current.value = _fmtd;

      if (props.onChange) {
        props.onChange({
          target: {
            name: e.target.name,
            value: _value,
          },
        });
      }
    },
    [em.type, numberFmt, props]
  );

  switch (em.type) {
    case 'ActionButtons':
      return (
        <td className={(em.class || '') + ' action-menu'} style={cellStyle}>
          {em.buttons &&
            em.buttons.map((t, i) => {
              return (
                <button
                  type="button"
                  className="btn"
                  key={i}
                  style={{ cursor: 'pointer' }}
                  onClick={(e) => {
                    e.preventDefault();
                    app && app.handlers && t.click && app.handlers[t.click] && app.handlers[t.click](data);
                  }}
                >
                  <i className={t.icon}></i>
                  {t.text && t.text !== '' && (
                    <React.Fragment>
                      <br />
                      <small>{t.text}</small>
                    </React.Fragment>
                  )}
                </button>
              );
            })}
        </td>
      );

    case 'ActionMenu':
      return (
        <td className={(em.class || '') + ' action-menu'} style={{ width: '1rem' }}>
          <div className="dropdown">
            <button
              className="btn btn-sm btn-light"
              type="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i className="fas fa-ellipsis-v"></i>
            </button>
            <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
              {em.buttons &&
                em.buttons.map((t, i) => {
                  if (t.type && t.type === 'hr') {
                    return <hr key={i} />;
                  }

                  return (
                    // eslint-disable-next-line jsx-a11y/anchor-is-valid
                    <a
                      key={i}
                      className="dropdown-item"
                      style={{ cursor: 'pointer' }}
                      onClick={(e) => {
                        e.preventDefault();
                        app && app.handlers && t.click && app.handlers[t.click] && app.handlers[t.click](data);
                      }}
                    >
                      {t.label}
                    </a>
                  );
                })}
            </div>
          </div>
        </td>
      );

    case 'CheckCell':
      return (
        <td className={'p-2 ' + em.class} style={cellStyle}>
          <input
            type="checkbox"
            className="form-control"
            name={em.field}
            value={data[em.field] || ''}
            checked={data[em.field] === 'Y'}
            onChange={props.onChange}
          />
        </td>
      );

    case 'TextCell':
      return (
        <td className={em.class} style={cellStyle}>
          <input
            className={`form-control ${inputClass}`}
            name={em.field}
            value={data && em.field && (data[em.field] || '')}
            onChange={props.onChange}
            list={em.datalist || props.datalist}
            autoComplete="off"
          />
        </td>
      );

    case 'DateCell':
      return (
        <td className={em.class} style={cellStyle}>
          <input
            ref={refInput}
            className={`form-control ${inputClass}`}
            name={em.field}
            // value={data && em.field && (data[em.field] || '')}
            // onChange={props.onChange}
            autoComplete="off"
          />
        </td>
      );

    case 'NumberCell':
      return (
        <td className={em.class} style={cellStyle}>
          <input
            ref={refInput}
            type="text"
            className={`form-control ${inputClass}`}
            name={em.field}
            // value={data && em.field && (data[em.field] || '')}
            onBlur={handleBlur}
            readOnly={em.readOnly}
            autoComplete="off"
          />
        </td>
      );

    case 'StaticSelectCell':
      return (
        <td className={em.class} style={cellStyle}>
          <select
            className="form-control"
            name={em.field}
            value={data && em.field && (data[em.field] || '')}
            onChange={props.onChange}
          >
            <option value="">---</option>
            {em.options &&
              em.options.map((t, i) => {
                return (
                  <option key={i} value={t.value}>
                    {t.text}
                  </option>
                );
              })}
          </select>
        </td>
      );

    case 'ValidSelectCell':
      return (
        <td className={em.class} style={cellStyle}>
          <select
            className="form-control"
            name={em.field}
            title={em.field}
            value={data && em.field && (data[em.field] || '')}
            onChange={props.onChange}
          >
            <option value="">---</option>
            {em.options &&
              app[em.options] &&
              app[em.options].map((t, i) => {
                return (
                  <option key={i} value={t.type_code}>
                    {t.type_desc}
                  </option>
                );
              })}
          </select>
        </td>
      );

    case 'DateViewCell': {
      // console.info(data[em.field]);
      const _d =
        data && em.field && data[em.field] && data[em.field] !== ''
          ? dateFmt.format(new Date(data[em.field]))
          : em.emptyText || '';
      return (
        <td className={em.class} style={cellStyle} onClick={handleCellClick}>
          {data && em.field && (_d || em.emptyText || '')}
        </td>
      );
    }

    case 'NumberViewCell': {
      const _d =
        data && em.field && data[em.field] && data[em.field] !== '' ? numberFmt.format(+`${data[em.field]}`) : '';
      return (
        <td className={em.class} style={cellStyle} onClick={handleCellClick}>
          {data && em.field && (_d || '')}
        </td>
      );
    }

    case 'ViewCell':
    default:
      if (Array.isArray(em.field)) {
        return (
          <td className={em.class} style={cellStyle} onClick={handleCellClick}>
            {data &&
              em.field &&
              em.field.map((t, i) => {
                if (t === '\n') {
                  return (
                    <React.Fragment key={i}>
                      <br />
                    </React.Fragment>
                  );
                }

                if (t.match(/\|/)) {
                  const flds = t.split('|');
                  return (
                    <React.Fragment key={i}>
                      {flds.map((f, z) => {
                        return (data[f] || '') + ' ';
                      })}
                      <br />
                    </React.Fragment>
                  );
                }

                // const fx = t.match(/@(.+):(.+)(:(.+))*/);
                if (t.substring(0, 1) === '@') {
                  const s = t.substring(1).split(':');
                  const fx = [t, ...s];
                  if (fx) {
                    if (typeof props.app[fx[1]] !== 'function') {
                      console.error(`${fx[1]} from ${t} is not function`, props.app);
                      return null;
                    }

                    let _data = data[fx[2]];
                    if (fx[3] && data[fx[3]]) {
                      _data = {};
                      _data[fx[2]] = data[fx[2]];
                      _data[fx[3]] = data[fx[3]];
                    }

                    return (
                      <React.Fragment key={i}>
                        {props.app[fx[1]](fx[2] === '?' ? data : _data || '')}
                        {/* <br /> */}
                      </React.Fragment>
                    );
                  }
                }

                const rxNumFmt = t.match(/(.+)#(.+)/);
                if (rxNumFmt) {
                  let _formatedValue = '';
                  let _fmt = integerFmt;
                  if (rxNumFmt[2] === '2') _fmt = fractionFmt2;

                  if (rxNumFmt[2] === 'd') {
                    _formatedValue =
                      data && data[rxNumFmt[1]] && data[rxNumFmt[1]] !== ''
                        ? dateFmt.format(new Date(data[rxNumFmt[1]]))
                        : '';
                  } else {
                    _formatedValue =
                      data && data[rxNumFmt[1]] && !isNaN(data[rxNumFmt[1]]) ? _fmt.format(data[rxNumFmt[1]]) : '##.##';
                  }

                  return (
                    <React.Fragment key={i}>
                      {_formatedValue}
                      &nbsp;
                    </React.Fragment>
                  );
                }

                return (
                  <React.Fragment key={i}>
                    {data[t] || ''} <br />
                  </React.Fragment>
                );
              })}
          </td>
        );
      }

      return (
        <td className={em.class} style={cellStyle} onClick={handleCellClick}>
          {data && em.field && (data[em.field] || '')}
        </td>
      );
  }
}

export function TableGrid(props) {
  const { app, em, data } = props;
  const { columns, addable, removable } = em;
  const { handlers } = app || {};

  const handleRowClick = useCallback(
    (idx) => {
      if (!handlers) {
        console.error("'handlers' is not found. 'app' property with 'handlers' must be assigned");
        console.info('<TableGrid em={...} data={...} app={...} />');
        return;
      }
      if (em.onRowClick && handlers[em.onRowClick]) handlers[em.onRowClick](idx);
    },
    [em.onRowClick, handlers]
  );

  const handleCellChange = useCallback(
    (e, idx) => {
      if (em.onChange && handlers[em.onChange]) handlers[em.onChange](e, idx);
    },
    [em.onChange, handlers]
  );

  return (
    <div className="table-responsive zeta-table">
      <table className="table table-sm " style={em.style}>
        <thead>
          <tr>
            {columns &&
              columns.map((t, i) => {
                return (
                  <th
                    key={i}
                    className={(t.class || '') + (t.type === 'ActionMenu' ? ' action-menu' : '')}
                    style={t.style}
                  >
                    {t.head || ''}
                  </th>
                );
              })}
            {removable && <th className="actions"></th>}
          </tr>
        </thead>
        <tbody>
          {data &&
            data[em.values] &&
            data[em.values].map((t, rowIndex) => {
              const _data_row = { ...data[em.values][rowIndex] };
              _data_row['@row_no'] = rowIndex + 1;
              return (
                <tr
                  key={rowIndex}
                  onClick={(e) => {
                    e.preventDefault();
                    handleRowClick(rowIndex);
                  }}
                >
                  {columns &&
                    columns.map((v, c) => {
                      return (
                        <TableCell
                          key={c}
                          em={v}
                          app={app}
                          lang={app.lang}
                          locale={app.locale}
                          data={_data_row}
                          onChange={(e) => handleCellChange(e, rowIndex)}
                        />
                      );
                    })}
                  {removable && (
                    <td style={{ width: '2em' }}>
                      <button
                        type="button"
                        className="btn btn-sm"
                        onClick={(e) => {
                          // console.info(rowIndex);
                          e.preventDefault();
                          if (handlers[em.onRemove]) handlers[em.onRemove](rowIndex);
                        }}
                      >
                        <i className="fas fa-trash"></i>
                      </button>
                    </td>
                  )}
                </tr>
              );
            })}
        </tbody>
        <tfoot>
          <tr>
            <td colSpan={(columns && columns.length) || 1} className="text-left">
              {addable && (
                <button
                  type="button"
                  className="btn btn-sm btn-secondary btn-icon-split"
                  onClick={handlers && em.onAdd ? handlers[em.onAdd] : null}
                >
                  <span className="icon text-white">
                    <i className="fas fa-plus"></i>
                  </span>
                  <span className="text d-none d-sm-inline">เพิ่มบรรทัด</span>
                </button>
              )}
            </td>
            {removable && <td>&nbsp;</td>}
          </tr>
        </tfoot>
      </table>
    </div>
  );
}

TableGrid.defaultProps = {
  em: {},
  app: { lang: 'en', locale: 'en-UK' },
};
